document.addEventListener('DOMContentLoaded', function() {
  const hoverImageTriggers = document.querySelectorAll('.card__hover-image-trigger');
  
  hoverImageTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const gridItem = this.closest('.grid__item');
      const overlay = gridItem.querySelector('.card__hover-image-overlay');
      
      if (overlay) {
        overlay.classList.toggle('active');
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.grid__item.has-hover-image')) {
      const activeOverlays = document.querySelectorAll('.card__hover-image-overlay.active');
      activeOverlays.forEach(function(overlay) {
        overlay.classList.remove('active');
      });
    }
  });
});
